/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ConsumableOrderItem from './consumable-order-item';
import ConsumableOrderItemDetail from './consumable-order-item-detail';
import ConsumableOrderItemUpdate from './consumable-order-item-update';
import ConsumableOrderItemDeleteDialog from './consumable-order-item-delete-dialog';

const ConsumableOrderItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ConsumableOrderItem />} />
    <Route path="new" element={<ConsumableOrderItemUpdate />} />
    <Route path=":id">
      <Route index element={<ConsumableOrderItemDetail />} />
      <Route path="edit" element={<ConsumableOrderItemUpdate />} />
      <Route path="delete" element={<ConsumableOrderItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ConsumableOrderItemRoutes;
